import { Base } from "../Base";
export class Class extends Base {
    name;
    class = "null";
    constructor(name = "null") {
        super();
        this.name = name;
    }
    is(value) {
        return value === null;
    }
    static create() {
        return new Class();
    }
}
//# sourceMappingURL=Class.js.map